var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default').default;

(function () {
  Flint.file('mframework/views/timestamp.js', function (require) {
    var _moment = require('moment');

    var _moment2 = _interopRequireDefault(_moment);

    Flint.staticStyles('Timestamp', {
      '$timestamp': '#_flintapp .ViewTimestamp'
    }, {
      '$timestamp': {}
    });
    Flint.viewRoots["Timestamp"] = 'timestamp';
    Flint.view('Timestamp', function (view, on, $) {
      var context = initContext(view, {
        fonts: atom()
      });

      var pro = initPro(view, {
        timestamp: atom()
      });

      var timestampString = atom((0, _moment2.default)(pro.timestamp.get()).fromNow());

      on.every(5000, function () {
        timestampString.set((0, _moment2.default)(pro.timestamp.get()).fromNow());
      });view.render(function () {
        return view.el(
          ['timestamp', 1],
          null,
          timestampString.get()
        );
      });

      $["timestamp"] = function (_, _index) {
        return {
          font: context.fonts.get().normal
        };
      };
    });
  })
})();
//# sourceMappingURL=timestamp.js.map
